import React from 'react';
import sewingImage from '../assets/Sewing.png';
import bnbIcon from '../assets/BNBicon.png';
import linkIcon from '../assets/link.png';

export default function WalletConnectModal({ isOpen, onClose, onBinanceClick }) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Базовые размеры модального окна
  const baseWidth = 660;
  const baseHeight = 400;
  const baseScreenWidth = 1920;
  
  // Вычисляем масштаб относительно ширины экрана
  const scale = window.innerWidth / baseScreenWidth;
  
  // Применяем масштаб к размерам
  const modalWidth = baseWidth * scale;
  const modalHeight = baseHeight * scale;

  const handleBinanceClick = () => {
    onClose();
    if (onBinanceClick) {
      onBinanceClick();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div 
        className="bg-[#191919] rounded-[30px] border border-[#414141] relative"
        style={{
          width: `${modalWidth}px`,
          height: `${modalHeight}px`,
          minWidth: '660px',
          minHeight: '400px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Красная шапка */}
        <div
          className="absolute"
          style={{
            top: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '140px',
            backgroundColor: '#520001',
            borderTopLeftRadius: '30px',
            borderTopRightRadius: '30px'
          }}
        >
          {/* Sewing Barcode - сверху по центру в красной шапке */}
          <div
            className="absolute"
            style={{
              left: '50%',
              top: '0px',
              transform: 'translateX(-50%)',
              width: '400px',
              height: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img
              src={sewingImage}
              alt="Sewing Barcode"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        </div>

        {/* Заголовок "Connect Your Wallet" */}
        <p
          className="absolute text-center"
          style={{
            left: '50%',
            top: '169px',
            transform: 'translateX(-50%)',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: '18px',
            color: 'rgba(255, 255, 255, 0.4)',
            margin: 0,
            whiteSpace: 'nowrap'
          }}
        >
          Connect Your Wallet
        </p>

        {/* Кнопка Binance Wallet */}
        <button
          onClick={handleBinanceClick}
          className="absolute cursor-pointer hover:opacity-90 transition-opacity"
          style={{
            left: '130px',
            top: '209px',
            width: '400px',
            height: '55px',
            backgroundColor: 'rgba(76, 76, 76, 0.4)',
            borderRadius: '8px',
            border: 'none',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            position: 'relative'
          }}
        >
          {/* Иконка BNB слева */}
          <div
            style={{
              width: '55px',
              height: '55px',
              backgroundColor: '#deaa00',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              borderRadius: '8px'
            }}
          >
            <img
              src={bnbIcon}
              alt="BNB Icon"
              style={{
                width: '40px',
                height: '40px',
                objectFit: 'contain'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>

          {/* Текст "Binance Wallet" по центру */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              paddingLeft: '81px',
              paddingRight: '81px'
            }}
          >
            <p
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '18px',
                color: 'rgba(255, 255, 255, 0.8)',
                margin: 0,
                whiteSpace: 'nowrap'
              }}
            >
              Binance Wallet
            </p>
          </div>

          {/* Иконка подключения справа */}
          <div
            style={{
              width: '55px',
              height: '55px',
              backgroundColor: '#deaa00',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              borderRadius: '8px'
            }}
          >
            <img
              src={linkIcon}
              alt="Connect Icon"
              style={{
                width: '35px',
                height: '35px',
                objectFit: 'contain'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        </button>

        {/* Текст внизу - Terms of Use */}
        <p
          className="absolute text-center"
          style={{
            left: '50%',
            top: '345px',
            transform: 'translateX(-50%)',
            width: '510px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: '18px',
            color: 'rgba(255, 255, 255, 0.4)',
            margin: 0,
            lineHeight: '1.4'
          }}
        >
          <span>By proceeding, you agree to </span>
          <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>Terms of Use</span>
          <span> & </span>
          <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>Privacy Policy</span>
          <span>.</span>
        </p>
      </div>
    </div>
  );
}

